"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PacketStatusEnumSchema = exports.documentSignatureHookEventDto = exports.PolicyAgreementStatusEnum = exports.DocumentSignatureStatusEnum = exports.DocumentStatusEnum = exports.SignatureEngineTypeEnum = exports.PacketTypeEnum = exports.CAN_SEE_SIGNERS_HEADER = void 0;
const zod_1 = require("zod");
exports.CAN_SEE_SIGNERS_HEADER = 'x-can-see-signers';
var PacketTypeEnum;
(function (PacketTypeEnum) {
    PacketTypeEnum["DOCUMENT_SIGNATURE"] = "document_signature";
    PacketTypeEnum["POLICY_AGREEMENT"] = "policy_agreement";
})(PacketTypeEnum = exports.PacketTypeEnum || (exports.PacketTypeEnum = {}));
var SignatureEngineTypeEnum;
(function (SignatureEngineTypeEnum) {
    SignatureEngineTypeEnum["CLICKSIGN"] = "clicksign";
    SignatureEngineTypeEnum["ELETRONIC"] = "eletronic";
})(SignatureEngineTypeEnum = exports.SignatureEngineTypeEnum || (exports.SignatureEngineTypeEnum = {}));
var DocumentStatusEnum;
(function (DocumentStatusEnum) {
    DocumentStatusEnum["PENDING_PREPARE_DATA"] = "PENDING_PREPARE_DATA";
    DocumentStatusEnum["PREPARING_DATA"] = "PREPARING_DATA";
    DocumentStatusEnum["CREATED"] = "CREATED";
    DocumentStatusEnum["CANCELED"] = "CANCELED";
    DocumentStatusEnum["REFUSED"] = "REFUSED";
})(DocumentStatusEnum = exports.DocumentStatusEnum || (exports.DocumentStatusEnum = {}));
var DocumentSignatureStatusEnum;
(function (DocumentSignatureStatusEnum) {
    DocumentSignatureStatusEnum["PENDING"] = "PENDING";
    DocumentSignatureStatusEnum["PENDING_SIGNATURE"] = "PENDING_SIGNATURE";
    DocumentSignatureStatusEnum["FAILED"] = "FAILED";
    DocumentSignatureStatusEnum["CANCELED"] = "CANCELED";
    DocumentSignatureStatusEnum["SIGNED"] = "SIGNED";
})(DocumentSignatureStatusEnum = exports.DocumentSignatureStatusEnum || (exports.DocumentSignatureStatusEnum = {}));
var PolicyAgreementStatusEnum;
(function (PolicyAgreementStatusEnum) {
    PolicyAgreementStatusEnum["PENDING"] = "PENDING";
    PolicyAgreementStatusEnum["RUNNING"] = "RUNNING";
    PolicyAgreementStatusEnum["FAILED"] = "FAILED";
    PolicyAgreementStatusEnum["REVOKED"] = "REVOKED";
    PolicyAgreementStatusEnum["SIGNED"] = "SIGNED";
})(PolicyAgreementStatusEnum = exports.PolicyAgreementStatusEnum || (exports.PolicyAgreementStatusEnum = {}));
exports.documentSignatureHookEventDto = zod_1.z.object({
    id: zod_1.z.string().min(1),
    new_status: zod_1.z.string().min(1),
    old_status: zod_1.z.string().min(1),
});
exports.PacketStatusEnumSchema = zod_1.z
    .nativeEnum(DocumentSignatureStatusEnum)
    .or(zod_1.z.nativeEnum(PolicyAgreementStatusEnum));
